<div *ngIf="item" class="catalog-detail">

    <!-- Hero -->
    <div class="hero mb-4 rounded-4 position-relative"
        [style.background-image]="'url(' + fileBaseUrl + '/' + item.coverFileId + ')'"
        style="background-size:cover;background-position:center;">
        <div class="overlay"></div>
        <div class="hero-content text-white">
            <h1 class="fw-bold">{{ item.title }}</h1>
            <p class="lead mb-0" *ngIf="item.subtitle">{{ item.subtitle }}</p>
        </div>
    </div>

    <!-- Descripción -->
    <div class="mb-5">
        <h2 class="section-title">Descripción</h2>
        <div class="description-content" [innerHTML]="safeDescription"></div>
    </div>

    <!-- Galería -->
    <div *ngIf="media.length" class="mb-5">
        <h2 class="section-title">Galería</h2>
        <div class="row g-3 g-md-4">
            <div *ngFor="let m of media" class="col-12 col-md-6 col-lg-4">
                <div class="gallery-card rounded-3 shadow-sm p-2 position-relative">

                    <!-- Badge -->
                    <span class="media-badge" [ngClass]="{
                  'badge-video': isVideo(m),
                  'badge-pdf': isPdf(m)
                }">
                        {{ isImage(m) ? 'Imagen' : (isVideo(m) ? 'Video' : 'PDF') }}
                    </span>

                    <!-- Imagen -->
                    <ng-container *ngIf="isImage(m)">
                        <img [src]="fileBaseUrl + '/' + m.fileId" [alt]="m.caption" class="w-100 rounded-3 thumb"
                            loading="lazy" style="cursor:pointer;"
                            (click)="imagePreview.openModal(fileBaseUrl + '/' + m.fileId!)">
                    </ng-container>

                    <!-- Video -->
                    <ng-container *ngIf="isVideo(m)">
                        <div class="video-wrap">
                            <video #vid class="thumb rounded-3 w-100" [src]="fileBaseUrl + '/' + m.fileId"
                                preload="metadata" muted playsinline (play)="hideOverlay(overlay)"
                                (pause)="showOverlay(overlay)" (ended)="showOverlay(overlay)">
                            </video>
                            <button #overlay class="play-overlay" type="button"
                                (click)="playVideo(vid, overlay, $event)">▶</button>
                        </div>
                    </ng-container>

                    <!-- PDF -->
                    <ng-container *ngIf="isPdf(m)">
                        <button type="button" class="pdf-tile w-100 h-100" (click)="openPdf(m)">
                            <span class="pdf-mark">PDF</span>
                        </button>
                    </ng-container>

                    <p *ngIf="m.caption" class="mt-2 small text-muted">{{ m.caption }}</p>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="plans.length" class="mb-5">
        <h2 class="section-title">Planes</h2>
        <div class="row g-3 g-md-4">
            <div *ngFor="let p of plans" class="col-12 col-md-6 col-lg-4">
                <div class="plan-card h-100 p-4 rounded-4 shadow-sm">
                    <h4 class="fw-bold">{{ p.name }}</h4>
                    <p class="text-secondary mb-1">{{ (p?.periodQty || 0) | periodLabel : p.periodUnitId}} </p>
                    <div class="price fw-bold">{{ p.price | currency }}
                        <span *ngIf="p.appliesITBIS">+ ITBIS</span>
                    </div>
                    <button class="btn btn-primary mt-3 w-100" (click)="onMainAction(p)">
                        {{ mainActionLabel }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Beneficios -->
    <div *ngIf="benefits.length" class="mb-5">
        <h2 class="section-title">Beneficios</h2>
        <div class="row g-3">
            <div *ngFor="let b of benefits" class="col-12 col-md-6 col-lg-4">
                <div class="benefit-card p-3 rounded-3 shadow-sm h-100 d-flex">
                    <div class="benefit-icon me-3">
                        <i class="fa-solid" [ngClass]="b.iconName"></i>
                    </div>
                    <div>
                        <h6 class="fw-bold mb-1">{{ b.title }}</h6>
                        <p class="text-secondary mb-0">{{ b.shortText }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<!-- Modal PDF -->
<div portalToBody class="modal fade" id="pdfModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ pdfPreviewName }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body p-0">
                <embed class="pdf-embed-fixed" [attr.src]="pdfPreviewSafe" type="application/pdf" />
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>

<!-- Componente de preview de imágenes -->
<app-image-preview #imagePreview></app-image-preview>